import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {getImagePathWithTheme, getImagePathWithThemeSvg} from "../../utils";
import { t } from "i18next";
import { ConfigProvider, Dropdown, Tooltip } from "antd";
import Icon, {CheckOutlined, DownOutlined, FolderOutlined, MoreOutlined, SearchOutlined} from '@ant-design/icons';
import {getProjectContentFilter, updateProjectContentSort} from "../../../model/projectContentFilter";
import {PROJECT_ID} from "./DrawIndex";
import global from "@/global";
import { useLocation } from "react-router";

const TreeListContentSort = forwardRef((props:{onRemoveUnusedCards:any,onRefreshList:any},ref)=>{
    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                // {
                //     key: 'sort by updateDate',
                //     label: t('Last viewed')
                // }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])

    const [sortMenuOpen, setSortMenuOpen] = useState(false);

    let params = useLocation();

    useEffect(() => {
        global.g_projectId = params.state?.noteData?.id;
        //PROJECT_ID的问题。必须延迟
        updateSortStates();
    }, []);

    /**排序*/
    const onSortMenuClick = async (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            await updateProjectContentSort(global.g_projectId,e.key,null);
            //默认选中Order by 的第一个.
            if("sort by name" == e.key){
                onSortMenuClick({key:'a-z'})
            }else{
                onSortMenuClick({key:'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            const projectContentFilterSort = await updateProjectContentSort(global.g_projectId,null,e.key);
            //更新列表
            props.onRefreshList(projectContentFilterSort);
        }
        await updateSortStates();
    }

    const updateSortStates = async ()=>{
        const projectContentSort = await getProjectContentFilter(global.g_projectId);
        let szSortType = projectContentSort?.sortBy || "sort by createDate";
        let szOrderBy = projectContentSort?.orderBy || "date desc";

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined />,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for(var i=0;i<item0.children.length;i++){
            var child = item0.children[i];

            if(child.key == szSortType){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for(var i=0;i<item1.children.length;i++){
            var child = item1.children[i];

            if(child.key == szOrderBy){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }


    return <ConfigProvider
        theme={{
            components: {
                Dropdown: {
                    colorBgElevated:'transparent',
                    colorPrimaryBorder:'transparent',
                    boxShadowSecondary:'transparent'
                }
            }
        }}
    >
        <Dropdown overlayClassName='default-dropdown-style' placement={'bottomLeft'} overlayStyle={{minWidth: '232px'}}
                  menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                  onOpenChange={handleSortOpenChange} open={sortMenuOpen} dropdownRender={(menu)=>{
            return (
                <div style={{background:'var(--dialog-background-color)',borderRadius:'8px',boxShadow:'var(--menu-box-shadow)'}}>
                    {React.cloneElement(
                        menu as React.ReactElement<{
                            style: React.CSSProperties;
                        }>,
                    )}
                    {/*<div className={'hovered-blue-no'} style={{color: '#E33E32',borderTop:'1px solid var(--line-color)',padding:'10px 22px',cursor:'pointer'}} onClick={()=>{*/}
                    {/*    setSortMenuOpen(false);*/}
                    {/*    window.showMessageBox(t("RemoveUnusedCards"),t("RemoveAllUnusedCardsTips"),t("Cancel"),t("Remove"),null,()=>{*/}
                    {/*        //移除未使用的card*/}
                    {/*        props.onRemoveUnusedCards();*/}
                    {/*    })*/}
                    {/*}}>*/}
                    {/*    <span>{t("RemoveUnusedCards")}</span>*/}
                    {/*</div>*/}
                </div>
            )
        }}>
            <Tooltip title={t("Sort")} arrow={false}>
                <img className={'img-14 cursor-pointer ml-10'} src={getImagePathWithTheme('content_sort.svg')}/>
            </Tooltip>
        </Dropdown>
    </ConfigProvider>
})

export default TreeListContentSort;